export class ExtentModel {

  constructor(public getIntersection: boolean) {
  }
}

// should be expanded when custom spatial extent can be selected
